<template>
  <div id="dashboard">
    <h1>Welcome to the dashboard!</h1>
    <p>You're here because you are authenticated!</p>

    <h1>The sidebar is {{ collapsed ? 'closed' : 'open' }}</h1>
    <button @click="toggleSidebar">Toggle Sidebar</button>

  </div>
</template>

<script>
  import { collapsed, toggleSidebar } from '@/components/sidebar/state'
  export default {
    setup() {
      return { collapsed, toggleSidebar }
    }
  }
</script>

<style scoped>
  h1, p {
    text-align: center;
  }

  p {
    color: white;
  }
</style>